import React from 'react';
export function Footer() {
  return <footer className="py-10 bg-bg border-t border-white/5 text-center" role="contentinfo" data-id="element-109">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-110">
        <div className="mb-8" data-id="element-111">
          <h3 className="text-2xl font-heading font-bold text-white mb-2" data-id="element-112">
            SISTEMA MAESTRO PVC + DVH
          </h3>
          <p className="text-gold font-medium mb-2" data-id="element-113">
            El sistema N°1 para talleres de aberturas en Argentina.
          </p>
        </div>

        <nav aria-label="Contacto y redes sociales" className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-gray-400 text-sm mb-10" data-id="element-114">
          <a href="mailto:soporteoficialfegion@gmail.com" className="hover:text-gold transition-colors" data-id="element-115">
            📧 soporteoficialfegion@gmail.com
          </a>
          <span className="hidden md:inline text-white/10" aria-hidden="true" data-id="element-116">
            |
          </span>
          <a href="#" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-117">
            📲 @fegion1
          </a>
          <span className="hidden md:inline text-white/10" aria-hidden="true" data-id="element-118">
            |
          </span>
          <a href="https://www.fegion.shop" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-119">
            🌐 www.fegion.shop
          </a>
        </nav>

        <div className="border-t border-white/5 pt-8" data-id="element-120">
          <p className="text-gray-400 text-sm mb-4" data-id="element-121">
            © Sistema Maestro PVC + DVH™ 2025 — Todos los derechos reservados.
          </p>
          <div className="text-gray-400 text-sm italic" data-id="element-122">
            <p data-id="element-123">🏗️ "Desde hoy, tu taller de PVC + DVH tiene sistema."</p>
          </div>
        </div>
      </div>
    </footer>;
}